import { render, staticRenderFns } from "./DetailListTable.vue?vue&type=template&id=66c22df4&scoped=true&"
import script from "./DetailListTable.vue?vue&type=script&lang=js&"
export * from "./DetailListTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailListTable.vue?vue&type=style&index=0&id=66c22df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c22df4",
  null
  
)

export default component.exports